import React from 'react'
// lib
import styled from 'styled-components'
// components
import CollapseIconOrigin from '../Icons/CollapseIcon'
// theme
import { colors } from 'themes'

// styled
const CollapseWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 16px 0;

  font-size: 18px;

  & > :first-child {
    margin-right: 6px;
  }
`

const CollapseIcon = styled(CollapseIconOrigin)`
  color: ${colors.blue500};
`

// types
interface Props {
  children: any
  disabled?: boolean
  className?: string
  isCollapsed: boolean
  handleClick: () => void
}

const Collapse: React.FC<Props> = ({ isCollapsed, handleClick, children, className, disabled }) => {
  return (
    <CollapseWrapper onClick={handleClick} className={className}>
      {!disabled && <CollapseIcon color={'inherit'} fontSize={'large'} collapsed={isCollapsed} />}
      <div>{children}</div>
    </CollapseWrapper>
  )
}

export default Collapse
